const isS3Image = (url) => {
  return (url?.indexOf('static.pietrastudio.com') > -1 || url?.indexOf('carbonclub.s3.amazonaws.com') > -1) ?? false;
};
const padAssets = (url) => {
  return url.startsWith('/_next') ? '/landing-pages' : '';
};
// Docs: https://aws.amazon.com/developer/application-security-performance/articles/image-optimization
export default function cloudfrontLoader({ src, width, quality }) {
  if (/\.svg/.test(src)) {
    return src.startsWith('http') ? src : `https://static.pietrastudio.com${padAssets(src)}${src}`;
  }
  if (src.startsWith('http') && !isS3Image(src)) {
    return src;
  }
  const url = src.startsWith('http')
    ? new URL(src)
    : new URL(`https://d151315muslonm.cloudfront.net${padAssets(src)}${src}`);
  url.hostname = 'd151315muslonm.cloudfront.net';
  const params = url.searchParams;
  url.searchParams.set('format', params.get('format') || 'auto');
  url.searchParams.set('width', width.toString());
  url.searchParams.set('quality', (quality || 75).toString());
  return url.href;
}
